export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

export const isMobile = () => {
    return window.innerWidth < 991 ? true : false
}